<template>
  <Expandable header="Attachments" class="mb-10">
    <div v-if="loading">
      <b-row class="mobile-table-header d-none d-md-flex px-2 py-2 mx-1">
        <b-col cols="12" md="6"> Name </b-col>
        <b-col cols="12" md="6"> File / Response </b-col>
      </b-row>
      <b-row
        class="px-md-4 py-2 d-flex align-items-center"
        v-for="(item, i) in files"
        :key="i"
      >
        <b-col cols="12" md="6" v-html="formattedLabel(item.name, item.rules)">
        </b-col>
        <b-col cols="12" md="6">
          <!-- fieldtype 2: Radio Button (Yes/No) -->
          <template v-if="item.fieldtype === 2">
            <yes-no
              v-model="item.radioValue"
              @input="inputRadio(i)"
              :disabled="isDisabled"
              :rules="item.rules.includes('required') ? 'required' : ''"
            ></yes-no>
          </template>
          <!-- fieldtype 1 or default: File Upload -->
          <template v-else>
            <div v-if="item.url" class="d-flex mt-2">
              <b-button @click="open(item)" variant="outline-primary" size="sm">
                View
              </b-button>
              <b-button
                class="mx-2"
                v-if="isAdmin"
                @click="remove(item)"
                variant="outline-danger"
                size="sm"
              >
                Delete
              </b-button>
            </div>
            <file-input
              v-else
              @input="input(i)"
              :disabled="isDisabled"
              :rules="item.rules"
              v-model="item.file"
              accept=".jpg,capture=camera,.jpeg,.png,.pdf"
            ></file-input>
          </template>
        </b-col>
      </b-row>
    </div>
  </Expandable>
</template>

<script>
import { openFile } from "../../../assets/js/common";
import { FIELD } from "../../../assets/js/rules";
import hospitalCreateMixins from "../../../assets/mixins/hospital.create.mixins";
import licenseService from "../../../assets/services/license.service";
import Expandable from "../../Expandable.vue";
import YesNo from "../../form/YesNo.vue";
export default {
  props: {
    value: Array,
    filesList: Array,
    isDisabled: Boolean,
  },
  mixins: [hospitalCreateMixins],
  components: { Expandable, YesNo },
  data() {
    return {
      rules: FIELD,
      files: [],
      loading: true,
    };
  },
  computed: {
    master() {
      return this.$store.getters.master;
    },
    uploads() {
      if (this.master.master_fileupload instanceof Array == false) return [];
      return this.master.master_fileupload.filter((item) => {
        return item.file_upload_type_id === 2;
      });
    },
  },
  watch: {
    uploads() {
      this.init();
    },
  },
  methods: {
    formattedLabel(label, rules) {
      if (!rules) return label;
      if (rules.indexOf("required") != -1)
        return label + " <span style='color:red'>*</span>";
      return label;
    },
    remove({ organ_license_fileupload_mapping_id }) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure you want to delete this attachment?",
        onConfirm: async () => {
          try {
            vm.$loader.show();
            let { data } = await licenseService.removeFile(
              organ_license_fileupload_mapping_id
            );
            let { status, msg } = data;
            if (status == false) {
              vm.$alert.show(msg);
            } else {
              vm.$emit("onFileRemoved", organ_license_fileupload_mapping_id);
            }
            vm.$loader.hide();
          } catch (error) {
            vm.$loader.hide();
            vm.$alert.show(error.message);
          }
        },
      });
    },
    open({ url }) {
      openFile(url);
    },
    init() {
      const vm = this;
      vm.files = vm.uploads.map((item) => {
        let { file_upload_name, file_upload_id, is_required, fieldtype } = item;
        // fieldtype: 1 = file upload, 2 = radio button (yes/no)
        let rules =
          is_required == 1
            ? "required|file-image-pdf|file-size"
            : "file-image-pdf|file-size";
        let file = vm.filesList.find((item) => {
          return item.file_upload_id == file_upload_id;
        });
        let url = null;
        let organ_license_fileupload_mapping_id = "";
        let radioValue = "";
        if (file instanceof Object) {
          url = file.file_name;
          organ_license_fileupload_mapping_id =
            file.organ_license_fileupload_mapping_id;
          // For radio button type, file_name stores the yes/no value
          if (fieldtype === 2) {
            radioValue = file.file_name || "";
          }
        }
        return {
          name: file_upload_name,
          file_upload_id,
          file: null,
          organ_license_fileupload_mapping_id,
          url,
          rules,
          fieldtype: fieldtype || 1,
          radioValue,
        };
      });
    },
    input() {
      const vm = this;
      this.$emit("input", vm.files);
    },
    inputRadio() {
      const vm = this;
      this.$emit("input", vm.files);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
